import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { TTranslatedTextTuple } from '../components/translation/models/translatedTextTuple'
import { ILocale } from '../models'
import { selectCurrentLocale } from '../selectors'

import { useSafetyTranslation } from './useSafetyTranslation'

export const useTranslatedText = (
  key: string,
  skipInterpolation?: boolean
): TTranslatedTextTuple => {
  const [currentKey, setCurrentKey] = useState<string>()
  const [currentLocale, setCurrentLocale] = useState<ILocale>()
  const [translatedText, setTranslatedText] = useState('')

  const locale = useSelector(selectCurrentLocale)
  const t = useSafetyTranslation()

  const updateTranslations = useCallback(() => {
    setTranslatedText(
      t(key, {
        interpolation: {
          skipOnVariables: skipInterpolation,
        },
      })
    )
  }, [t, key, skipInterpolation])

  useEffect(() => {
    if (locale && currentLocale?.name !== locale.name) {
      setCurrentLocale(locale)
      updateTranslations()
    }
  }, [currentLocale?.name, updateTranslations, locale])

  useEffect(() => {
    if (currentKey !== key) {
      setCurrentKey(key)
      updateTranslations()
    }
  }, [key, currentKey, updateTranslations])

  return [translatedText, setTranslatedText]
}
